<template>
	<input v-model="value" type="text" :name="name" />
</template>

<script>

import { mapReplace } from 'utils/text';

export default{
    props : {
        type : {
            type	: String,
            required : true
        },
        params : {
            required : false
        },
        max : {
            required : false,
            default	 : null,
        },
        name : {
            required : true
        },
        searchonfocus : {
            required	: false,
            default		: false
        },
        prepopulate : {
            required : false,
            // type	: Array,
        },
        allowCustomEntry : {
            type		: Boolean,
            required	: false,
            default		: false
        },
        more : {
            required : false,
            default	: function(){
                return {}
            }
        },
        searchname : {
            required 	: false,
            default		: "name"
        },
        minChars : {
            type: Number,
            required : false,
            default : 2
        }
    },
    data : function(){
        return {
            ajaxParams : {
                tag : {
                    action : 'tags',
                    method : 'autocompletion',
                },
                third : {
                    action : 'thirds',
                    method : 'search',
                    resultsFormatter : (third) => {
                        let htmlFormater = "<li style='width:100%;'>"
                        htmlFormater    +=   "<div style='height:40px; padding: 5px;'>"
                        htmlFormater    +=     "<span>"+third.name+"</span><br />"
                        htmlFormater    +=     "<span style='font-size:10px;' class='gray-60'>"+third.fullName+"</i>"
                        htmlFormater    +=   "</div>"
                        htmlFormater    += "</li>"
                        return htmlFormater
                    }
                },
                staff : {
                    action : 'staff',
                    method : 'autocompletion',
                },
                group : {
                    action : 'sharepoint',
                    method : 'autoCompleteGroup',
                },
                item : {
                    action : 'catalogue',
                    method : 'autocomplete',
                    resultsFormatter : (item) => {
                        let htmlFormater = "<li style='width:100%; display:table;' class='formated_auto_item ac-item '>"
                        htmlFormater    +=   "<div class='auto_item_pc' style='display:table-cell;width:40px; text-align:center;'>"
                        htmlFormater    +=     "<img style='width:25px;height:25px' src='"+item.pic+"'/>"
                        htmlFormater    +=   "</div>"
                        htmlFormater    +=   "<div class='auto_item_desc' style='display:table-cell;vertical-align:middle;'>"
                        htmlFormater    +=     "<span>"+item.name+"</span><br />"
                        htmlFormater    +=     "<span style='font-size:10px;' class='gray-60'>"+item.tradename+"</i>"
                        htmlFormater    +=   "</div>"
                        htmlFormater    += "</li>"

                        return htmlFormater
                    }
                },
                people : {
                    action : 'people',
                    method : 'autocompletion'
                },
                contacts : {
                    action : 'contacts',
                    method : 'autocompletion'
                },
                project : {
                    action : 'project_ajax',
                    method : 'autocompletion'
                },
                cashtill : {
                    action : 'pos_cashtills',
                    method : 'autocompletion'
                },
                document : {
                    action : 'doc',
                    method : 'autocompletion'
                }
            },
            value : {},
        }
    },
		
    computed : {

        queryString (){
            const urlSearchParams = new URLSearchParams(this.params);
            return urlSearchParams.toString();
        },

        jsonContainer () {
            if(this.type == 'third'){
                return 'results';
            }
            return 'root';
        },

        queryParam () {
            if(this.type == 'third'){
                return 'q';
            }
            return 'value';
        }
    },

    mounted : function(){

        var self = this;
        var placeholder = "";
        var ajaxParams = this.ajaxParams[this.type];

        for(const itm of this.prepopulate){
            this.value[itm.id] = itm;
        }
        if (this.prepopulate) {
            this.prepopulate.forEach(element => {
                if(element.name){
                    element.name = this.mapReplace(element.name, {
                        '&lt;': '<',
                        '&gt;': '>'
                    });
                }
					
            });
        }
        var settings = {
            action				: ajaxParams.method,
            preventDuplicates	: true,
            hintText			: Loc.g('Saisissez quelques lettres'),
            noResultsText		: Loc.g('Aucun résultat correspondant'),
            searchingText		: Loc.g('Recherche en cours...'),
            queryParam 			: this.queryParam,
            jsonContainer 		: this.jsonContainer,
            searchOnFocus		: this.searchonfocus,
            more				: this.more,
            minChars			: this.minChars,
            tokenLimit			: this.max,
            allowCustomEntry	: this.allowCustomEntry,
            tokenValue			: 'id',
            propertyToSearch	: this.searchname,
            placeholderText		: (placeholder == '' || placeholder == undefined ) ? Loc.g('Rechercher') : placeholder,
            classes 			: { tokenList : 'token-input-list token-input-one wp-10 mh-4'},
            prePopulate			: this.prepopulate,
            onAdd				: function(item){
                self.value[item.id] = item;
                self.$emit('updated', self.value);
            },
            onDelete			: function(item){
                delete self.value[item.id];
                self.$emit('updated', self.value);
            },
        };

        if ("resultsFormatter" in ajaxParams) {
            settings.resultsFormatter = ajaxParams.resultsFormatter
        }

        $("input[name="+this.name+"]").tokenInput('/?_f='+ajaxParams.action+(this.queryString !== '' ? '&'+this.queryString : ''), settings);
    },
    methods: {
        mapReplace(str, map = {}){
            for (const [replace, pattern] of Object.entries(map)) {
                str = str.replace(new RegExp(pattern, 'g'), replace);
            };
            return str;
        }
    }
}
</script>
